import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

import ArrowNext from "./arrow-next.svg";
import ArrowPrevious from "./arrow-previous.svg";

export const Container = styled.div``;

export const Header = styled.div`
  margin-block-end: 8px;

  color: #000000;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  text-align: center;
  text-transform: uppercase;

  opacity: 0.5;
`;

export const DayText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 157px;
  block-size: 100%;
  margin-inline: auto;

  color: #001246;
  font-weight: 700;
  font-size: 16px;
`;

export const StyledSwiper = styled(Swiper)`
  margin-block-end: 8px;
  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    margin-block-end: 0;
  }
  & > .swiper-wrapper {
    block-size: 19px;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)``;

export const SwiperContainer = styled.div`
  position: relative;

  margin-block-end: 8px;
  .swiper-button {
    z-index: 1;
  }

  .today-highlights-swiper-button-disabled {
    opacity: 0.5;
  }
`;

const ArrowStyle = css`
  position: absolute;
  inset-block-start: 50%;
  z-index: 1;

  cursor: pointer;

  transform: translate(-50%, -50%);
`;

export const StyledArrowNext = styled(ArrowNext)`
  ${ArrowStyle};
  inset-inline-end: calc(50% - 102px);
`;

export const StyledArrowPrevious = styled(ArrowPrevious)`
  ${ArrowStyle};
  inset-inline-start: calc(50% - 95px);
`;
